import { Component } from '@angular/core';

@Component({
    selector: 'app-authenticated-layout',
    templateUrl: './authenticated-layout.component.html',
    styleUrls: ['./authenticated-layout.component.scss']
})
export class AuthenticatedLayoutComponent {}
